import { Html, useGLTF, useTexture, useProgress } from '@react-three/drei'
import { CuboidCollider, RigidBody } from '@react-three/rapier'
import { Model } from './Model';
import * as THREE from 'three'
import { useFrame } from '@react-three/fiber';
import { useEffect } from 'react';

let gamePlaying;

THREE.ColorManagement.legacyMode = false;


const floorGeometry = new THREE.BoxGeometry(1, 1, 1);
const wallMaterial = new THREE.MeshStandardMaterial({ color: 'white' });

const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1);
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
    void main()
    {
        gl_Position =  vec4(position, 1.0);
    }
    `,
    fragmentShader: `
    uniform float uAlpha;

    void main()
    {
        gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
    }
    `
});




function BlockStart({ position = [0, 0, 0] }) {
    return <group position={position}>
        <RigidBody type='fixed' restitution={0.2} friction={0}>

            {/* FLOOR COLLIDER */}
            <CuboidCollider args={[5.5, 1, 20]}
                position={[0, -1.3, 3.2]}
                restitution={0.2}
                friction={1} />

            {/* TABLE TV */}
            <CuboidCollider args={[5.5, 10, 1]}
                position={[0, 1, 1]}
                restitution={0.2}
                friction={1}

            />



        </RigidBody>
    </group>
}

function Bounds() {
    return <>
        <RigidBody type='fixed'
            restitution={0.2}
            friction={0}>
            {/* BACK WALL */}
            <mesh geometry={floorGeometry}
                position={[0, 0.1, 12]}
                scale={[12, 6.5, 0.5]}
                material={wallMaterial}
                castShadow
            />
            {/* RIGHT WALL */}
            <mesh geometry={floorGeometry}
                position={[6.5, 5, 2]}
                scale={[2, 10, 30]}
                material={wallMaterial}
                castShadow
            />

            {/* LEFT WALL */}
            <mesh geometry={floorGeometry}
                position={[-6.4, 5, 10]}
                scale={[2, 10, 35]}
                material={wallMaterial}
                castShadow
            />

        </RigidBody>
    </>
}



export default function Level() {
    <color args={['#030202']} attach="background" />

    return <>
        <Model />
        <Bounds />
        <BlockStart position={[0, 0, 0]} />
    </>
}